import type { Collaborator } from '@components/ArtBoard/Collaboration/types'
import { Tooltip } from '@lib/components'

import { AvatarRenderer } from '../AvatarRenderer/AvatarRenderer'

type CollaborationViewersStackProps = {
  collaborators: Collaborator[]
}

export const CollaborationViewersStack = ({
  collaborators,
}: CollaborationViewersStackProps) => {
  return (
    <>
      {collaborators.map((collaborator) => (
        <Tooltip
          key={collaborator.id}
          content={`${collaborator.firstName} ${collaborator.lastName}`}
          position="bottom"
          spacing="md"
        >
          <AvatarRenderer collaborator={collaborator} />
        </Tooltip>
      ))}
    </>
  )
}
